import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Home';
import { getProjectCss } from './lib/utils';


function App() {
  const APP_ROOT = process.env.REACT_APP_PAGE_ROOT
  console.log({APP_ROOT})
  getProjectCss()
  return (
    <BrowserRouter>
      <Routes>
        <Route path={APP_ROOT} element={<Home />}>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App;
